<template lang="pug">
v-dialog(v-model='dialog' width='886px' height='auto' @click:outside='closeDialog()')
    v-card(style='max-width: 100%; padding-bottom: 20px;')
      v-toolbar.toolbar-settings.text-settings(style='z-index: 99999')
        span(style='font-size: 1.125rem;shaped line-height: 1.4em; font-weight: 300; font-size: 18px;') Inserir destinatário
        v-spacer
        v-btn#closeIcon(icon color='white' @click='closeDialog()')
          md-icon close
      ValidationObserver(ref="validationObserver" v-slot="{ invalid }")
        v-form(ref="registerRecipient" lazy-validation)
          v-card-text.content-dialog
            section
              .title-section(style='font-weight: 400; font-size: 22px;') {{$t('campaign.templateData')}}:
              v-skeleton-loader(v-if='isLoading' #dark style='width: 50%;' type="text@2, image")
              .template-preview(v-else)
                div {{$t('campaign.sender')}}: {{ ' ' }}
                  span(v-for="(from, index) in senderArray" :key="from") {{ from }}
                    span(v-if="index < senderArray.length - 1")
                      | ,
                div {{$t('commonWords.channel')}}: {{ ' ' }}
                  span(v-for="(channel, index) in activeChannels" :key="channel") {{channel}}
                    span(v-if="index < activeChannels.length - 1")
                      | ,
                div
                  p(style='margin: 0px;') {{$t('campaign.templateName')}}: {{ ' ' }}
                    span {{template.name}}
                div {{$t('campaign.templateText')}}:
                TextEditor.text-editor(ref="texEditor" :value="textMessage" disabled theme="bubble")
                .quick-replies-buttons
                  .d-flex.flex-wrap(v-if="!activeChannels.includes('sms') && template.messageOptions && template.messageOptions.options.quick_replies.length > 0" style="gap: 1rem;")
                    v-btn(
                      v-for="quickReply in template.messageOptions.options.quick_replies"
                      :key="quickReply.content"
                      disabled
                    ) {{quickReply.title}}
            section
              .title-section(style='font-weight: 400; margin: 20px 0px; font-size: 22px;') {{$t('campaign.insertUserData')}}
              .d-flex.flex-column(style='gap: 15px;')
                v-skeleton-loader(v-if='isLoading' type="image" style='height: 56px;')
                ValidationProvider(v-else rules="required" v-slot="{ errors }")
                  v-text-field.mr-3(
                    v-model='recipient.name'
                    filled
                    shaped
                    dense
                    :error-messages='errors'
                    :placeholder="$t('campaign.username')"
                  )
                v-skeleton-loader(v-if='isLoading' type="image" style='height: 56px;')
                ValidationProvider(v-else rules="required" v-slot="{ errors }")
                  VPhone.mr-3(
                    v-if="(activeChannels.includes('whatsapp') || activeChannels.includes('sms'))"
                    :value='phone'
                    :rules="[rules.required]"
                    @input='updatePhoneNumber'
                  )
                ValidationProvider(rules="required|email" v-slot="{ errors }")
                  v-text-field.mr-3(
                    v-if="(activeChannels.includes('teams'))"
                    v-model="channels[2].to"
                    v-mask='channels[2].mask'
                    filled
                    shaped
                    dense
                    :error-messages='errors'
                    :placeholder="$t(channels[2].receiverLabel)"
                  )
            section(v-if="templateFields.length > 0")
              .title-section {{$t('campaign.parameters')}}
              .d-flex.justify-space-between.align-center
                div(v-for="field in templateFields" :key="field")
                  ValidationProvider(rules="required" v-slot="{ errors }")
                    v-text-field(
                      v-model="templateFieldValues[field]"
                      :placeholder="field"
                      filled
                      shaped
                      dense
                      :rules="[rules.required]"
                    )
            v-card-actions.text-right
              v-btn(@click='closeDialog()' text style='margin-right: 10px') {{$t('commonWords.cancel')}}
              v-btn(
                @click='canSave ? saveRecipient(): sendRecipient()'
                color='#43a047'
                :disabled='invalid || isLoading'
                style='color: white;') {{$t('commonWords.send')}}
</template>

<script>
import { required, email } from 'vee-validate/dist/rules'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import clonedeep from 'lodash.clonedeep'
import Swal from 'sweetalert2'
import { mask } from 'vue-the-mask'
import { mapState } from 'vuex'
import TextEditor from '../TextEditor.vue'
import VPhone from '../VPhone.vue'
import i18N from '@/plugins/i18n'

extend('required', {
  ...required,
  message: i18N.t('commonPhrases.requiredField')
})

extend('email', {
  ...email,
  message: i18N.t('campaign.invalidEmailMessage')
})

const isValidEmail = (email) => {
  const reg =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

export default {
  components: {
    TextEditor,
    VPhone,
    ValidationObserver,
    ValidationProvider
  },
  props: {
    dialog: {
      type: Boolean
    },
    canSave: {
      type: Boolean,
      default: true
    },
    item: {
      type: Object
    },
    templateId: {
      type: String
    },
    campaignId: {
      type: String
    }
  },
  directives: {
    mask: (el, binding) => {
      if (!binding.value) return
      mask(el, binding)
    }
  },
  data () {
    return {
      recipientId: undefined,
      recipient: {
        active: true
      },
      templateFields: [],
      template: {},
      textMessage: '',
      activeChannels: [],
      isLoading: true,
      channels: [
        {
          channel: 'whatsapp',
          from: null,
          to: null
        },
        {
          channel: 'sms',
          from: null,
          to: null
        },
        {
          channel: 'teams',
          from: null,
          to: null,
          senderLabel: 'campaign.senderTeams',
          receiverLabel: 'campaign.receiverTeams',
          mask: undefined
        }
      ],
      channelSettings: undefined,
      templateFieldValues: {},
      rules: {
        required: (v) => !!v || this.$t('commonPhrases.requiredField'),
        isValidEmail: (channel) => channel === 'teams' ? (v) => isValidEmail(v) || 'E-mail inválido. Por favor, verifique.' : true
      },
      senderArray: [],
      phone: ''
    }
  },
  computed: {
    ...mapState('selectedAssistant', ['assistantId'])
  },
  async created () {
    if (!this.channelSettings) {
      await this.getChannelConfig()
    }
    if (this.templateId) {
      await this.handleTemplateUpdate()
      this.handleInitData()
      this.isLoading = false
    }
  },
  methods: {
    updatePhoneNumber (phoneNumber) {
      this.phone = phoneNumber
    },
    validateForm () {
      if (this.$refs.registerRecipient.validate()) return true
      return false
    },
    setSenderArray () {
      this.senderArray = this.channels.filter((channel) => this.activeChannels.includes(channel.channel)).map((channel) => channel.from)
    },
    handleInitData () {
      if (this.item && this.item._id) {
        this.recipientId = this.item._id
        let newChannel = []
        this.recipient = clonedeep(this.item._source)
        newChannel = this.channels.map(channel => {
          let findItem = this.recipient.contacts.find(item => item.channel === channel.channel)
          if (findItem) {
            return {
              ...channel,
              to: findItem.to,
              from: findItem.from
            }
          } else {
            return { ...channel }
          }
        })
        this.channels = newChannel
        this.recipient = clonedeep(this.item._source)
        if (this.recipient.messageOptions?.length > 0) {
          this.templateFields = this.recipient.messageOptions.map(item => {
            return Object.keys(item)[0]
          })
          this.recipient.messageOptions.forEach(item => {
            this.$set(this.templateFieldValues, Object.keys(item)[0], Object.values(item)[0])
          })
        }
      }
      this.setDefaultSenderValue()
    },
    async handleTemplateUpdate () {
      if (this.templateId) {
        this.template = await this.getTemplate()
        this.templateFields = this.template?.messageOptions?.text[0]?.match(/(?<={{)(.*?)(?=}})/g) ?? []
        this.templateFields.forEach((field) => {
          this.$set(this.templateFieldValues, field, '')
        })
        this.textMessage = this.template?.messageOptions?.text[0]
        this.activeChannels = this.template.channels.filter(channel => channel.isActive).map(channel => channel.name)
      }
    },
    closeDialog () {
      this.$emit('update:dialog', false)
    },
    async getTemplate () {
      const response = await this.$axios.get(`${process.env.VUE_APP_BACKEND_BASE_URL}/message-templates/${this.templateId}`)
      return response.data._source
    },
    async getChannelConfig () {
      try {
        const request = await this.$axios.get(`/assistant-configs/channels`)
        this.channelSettings = request?.data
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: this.$t('testNotificationDialog.thereWasAnErrorInYourRequest')
        })
      }
    },
    buildRecipientPayload () {
      const payload = {
        ...this.recipient,
        contacts: this.channels
          .map(item => {
            const { channel, from, to } = item
            let formatTo = to?.replace(/[()\s-]/g, '') || ''
            if (this.activeChannels.includes(channel)) {
              return {
                channel,
                from,
                to: (channel === 'whatsapp' || channel === 'sms') ? this.phone : formatTo.trim()
              }
            } else {
              return {
                channel,
                from,
                to: formatTo.trim()
              }
            }
          }),
        messageOptions: []
      }
      if (this.templateFields.length > 0) {
        this.templateFields.forEach((field) => {
          payload.messageOptions.push({
            [field]: this.templateFieldValues[field]
          })
        })
      }
      return payload
    },
    async saveRecipient () {
      try {
        if (this.$refs.registerRecipient.validate()) {
          const payload = this.buildRecipientPayload()
          if (this.recipientId) {
            await this.$axios.put(`/campaign/${this.campaignId}/contacts/${this.recipientId}`, payload)
          } else {
            await this.$axios.post(`/campaign/${this.campaignId}/contacts`, payload)
          }
          Swal.fire({
            title: this.recipientId ? this.$t('campaign.recipientSuccessfullyEdited') : this.$t('campaign.recipientCreatedSuccessfully'),
            icon: 'success',
            showConfirmButton: false,
            timer: 2000
          })
          setTimeout(() => {
            this.$emit('rerender')
            this.closeDialog()
          }, 2000)
        }
      } catch (error) {
        if (error.response?.data.error === 'RECIPIENT_ALREADY_EXISTS') {
          Swal.fire({
            icon: 'error',
            title: '',
            html: `${this.$t('campaign.recipientsAlreadyExist')}`
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: '',
            html: `${error}`
          },
          this.closeDialog())
        }
      }
    },
    sendRecipient () {
      if (this.$refs.registerRecipient.validate()) {
        const payload = this.buildRecipientPayload()
        this.$emit('recipientList', payload)
        this.$emit('getContacts')
        this.closeDialog()
      }
    },
    setDefaultSenderValue () {
      let newChannel = this.channels.map((channel) => {
        if (channel.channel === 'teams') {
          return {
            ...channel,
            from: this.channelSettings?.fromTeams
          }
        }
        if (channel?.channel === 'whatsapp') {
          return {
            ...channel,
            from: this.channelSettings?.fromWhatsapp
          }
        }
        if (channel?.channel === 'sms') {
          return {
            ...channel,
            from: this.channelSettings?.fromSMS
          }
        }
      })
      this.channels = [...newChannel]
      this.setSenderArray()
    }
  }
}
</script>

<style lang="scss" scoped>

.title-section{
  margin: 15px 0 10px;
  font-size: 16px;
  color: #000000;
}

.v-text-field {

  &.shaped {
    border-radius: 10px 10px 0px 0px;
  }
}

.content-dialog {
  padding: 10px 30px !important;
}

.v-input {
  ::v-deep .v-text-field__details {
    display: none !important;
  }
}

.v-input.error--text {
  ::v-deep .v-text-field__details {
    display: flex !important;
  }
}
  .v-text-field {

  &.v-input--is-focused {
    ::v-deep fieldset {
      border: none;
    }
  }
  ::v-deep fieldset {
    border: none;
  }
}

.md-switch {
  ::v-deep .md-switch-label {
    color: rgba(0, 0, 0, .6);
  }
}

.v-select {
  ::v-deep label {
    color: #949494;
  }
}

.text-editor {
  margin-top: 5px;
  & ::v-deep .quill-editor .ql-container {
    background-color: transparent !important;
    border: 0 !important;
    & .ql-editor {
      padding: 0 !important;
    }
  }
}

.template-preview {
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: #6D6D6D;
}

.v-card__actions {
  width: 100%;
}
</style>
